import React from "react";
import {
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoPurposeXs from "./small-ui/InfoPurposeXs";

const InfoPurpose = ({ id, isXs }) => {
  const { t } = useTranslation();

  if (isXs) return <InfoPurposeXs id={id} />;

  return (
    <Paper elevation={1} sx={{ p: 4, mb: 4 }} id={id}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <i className="fas fa-bullseye fa-2x" style={{ color: "#0c4d96" }}></i>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ ml: 2 }}
        >
          {t("privacy-policy.info-purpose.title")}
        </Typography>
      </Box>

      <Typography paragraph>
        {t("privacy-policy.info-purpose.intro")}
      </Typography>

      <List>
        {t("privacy-policy.info-purpose.purposes", { returnObjects: true }).map(
          (purpose, index) => (
            <ListItem key={index}>
              <ListItemText primary={`(${index + 1})${purpose}`} />
            </ListItem>
          )
        )}
      </List>

      <Typography variant="caption" sx={{ mt: 2, display: "block" }}>
        {t("privacy-policy.info-purpose.note")}
      </Typography>
    </Paper>
  );
};

export default InfoPurpose;
